export default __webpack_public_path__ + "static/high-scale-0c89fa71c4cc9774d60b64a88b2ec0c1.svg";